import angular from 'angular';
import AcsrCustomerSwitchComponent from './acsrCustomerSwitch.component';
import { routing as RoutingConfig } from './acsrCustomerSwitch.config';
export default angular.module('invision.customercare.acsrCustomerSwitch', []).config(RoutingConfig).component('acsrCustomerSwitch', AcsrCustomerSwitchComponent).name;